import React from 'react';
import './FAQs.css';

// Import required components (remove faqsContent from constants)
import { Faqs, Heading } from '../../../components';
import { images } from '../../../constants';

const FAQs = ({ faqsContent }) => {

  return (

    <section className='faq-section'>

      {/* Section heading */}
      <Heading title={'Frequently Asked Questions'} subTitle={"FAQ's"} />

      <div className='box-container'>

        {/* Faq Accordion container */}
        <Faqs faqs={faqsContent} />

        {/* Faq Image */}
        <div className='image'>
          <img src={images.FAQs} alt='FAQs-Pic' />
        </div>

      </div>

    </section>

  );
};

export default FAQs;